export class ApiStatus {
  status: any;
  xoLibraries: any;
}